import { useEffect, useState } from "react";
import { IClientes } from "../../interfaces/IClientes";
import { Modal } from 'react-bootstrap-v5';
import clsx from "clsx";
import * as Yup from 'yup';
import { useFormik } from 'formik';
import ClientesService from "../../services/ClientesService";
import { LISTA_ESTADOS, MASCARA_CEP, MASCARA_CNPJ, MASCARA_DATA, MASCARA_TELEFONE } from "../../utils/Constants";
import MaskedInput from "react-text-mask";
import IBGEService from "../../services/IBGEService";
import { IMunicipioIBGE } from "../../interfaces/IMunicipioIBGE";

const ClientesModal = ({ toggleModal, show, cliente, title }: { toggleModal: (recarregarInformacoes?: boolean) => void, show: boolean, cliente: IClientes, title: string }) => {

  const [municipios, setMunicipios] = useState<IMunicipioIBGE[]>([]);
  const clienteSchema = Yup.object().shape({
    cnpj: Yup.string().min(10, 'Mínimo 18 caracteres').max(18, 'Máximo 18 caracteres').required('CNPJ é obrigatório').matches(/^([0-9]{2}\.[0-9]{3}\.[0-9]{3}\/[0-9]{4}-[0-9]{2})$/),
    dataAberturaString: Yup.string().min(10, 'Mínimo 10 caracteres').max(10, 'Máximo 10 caracteres').required('Data de Abertura é obrigatório'),//.matches(/^([0-9]{2}\/[0-9]{2})\/[0-9]{4})$/),
    razaoSocial: Yup.string().max(50, 'Máximo 50 caracteres').required('Razão Social é obrigatório'),
    nomeFantasia: Yup.string().max(50, 'Máximo 50 caracteres').required('Nome Fantasia é obrigatório'),
    porte: Yup.string().max(50, 'Máximo 50 caracteres').required('Porte é obrigatório'),
    atividadePrincipal: Yup.string().max(250, 'Máximo 250 caracteres').required('Atividade Principal é obrigatório'),
    atividadeSecundaria: Yup.string().max(250, 'Máximo 250 caracteres'),
    cep: Yup.string().required('CEP é obrigatório'),//.max(9, 'Mínimo 9 caracteres').max(9, 'Máximo 9 caracteres').matches(/^([0-9]{5}-[0-9]{3})$/),
    endereco: Yup.string().max(50, 'Máximo 50 caracteres').required('Endereço é obrigatório'),
    numero: Yup.string().max(50, 'Máximo 50 caracteres').required('Número é obrigatório'),
    complemento: Yup.string().max(250, 'Máximo 250 caracteres'),
    bairro: Yup.string().max(100, 'Máximo 100 caracteres').required('Bairro é obrigatório'),
    cidade: Yup.string().max(100, 'Máximo 100 caracteres').required('Cidade é obrigatório'),
    estado: Yup.string().min(2, 'Mínimo 2 caracteres').max(2, 'Máximo 2 caracteres').required('Estado é obrigatório'),
    email: Yup.string().email().max(100, 'Máximo 100 caracteres').required('E-mail é obrigatório'),
    telefone: Yup.string().min(10, 'Máximo 10 caracteres').max(16, 'Máximo 16 caracteres').required('Telefone é obrigatório'),
    telefoneAdicional: Yup.string().min(10, 'Mínimo 10 caracteres').max(16, 'Máximo 16 caracteres'),
    situacaoCadastral: Yup.string().max(100, 'Máximo 100 caracteres').required('Situação Cadastral é obrigatório'),
    dataSituacaoCadastralString: Yup.string().min(10, 'Mínimo 10 caracteres').max(10, 'Máximo 10 caracteres').required('Data de Situação Cadastral é obrigatório'),
    motivoSituacaoCadastral: Yup.string().max(250, 'Máximo 250 caracteres'),
    situacaoEspecial: Yup.string().max(100, 'Máximo 100 caracteres'),
    dataSituacaoEspecialString: Yup.string().min(10, 'Mínimo 10 caracteres').max(10, 'Máximo 10 caracteres'),
    clienteDesdeString: Yup.string().min(10, 'Mínimo 10 caracteres').max(10, 'Máximo 10 caracteres').required('Cliente Desde é obrigatório')
  });

  const formInitialValues: IClientes = {
    id: 0,
    cnpj: '',
    dataAberturaString: '',
    razaoSocial: '',
    nomeFantasia: '',
    porte: '',
    atividadePrincipal: '',
    atividadeSecundaria: '',
    cep: '',
    endereco: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    estado: '',
    email: '',
    telefone: '',
    telefoneAdicional: '',
    situacaoCadastral: '',
    dataSituacaoCadastralString: '',
    motivoSituacaoCadastral: '',
    situacaoEspecial: '',
    dataSituacaoEspecialString: '',
    clienteDesdeString: ''
  };
  const formik = useFormik({
    initialValues: formInitialValues,
    validationSchema: clienteSchema,
    onSubmit: async (cliente, { setSubmitting }) => {
      function funcaoSucesso() {
        setSubmitting(false);
        toggleModal(true);
      }

      if (cliente.dataAberturaString) {
        const dataAberturaPedacos = cliente.dataAberturaString.split('/') ?? [];
        const dataAberturaString = `${dataAberturaPedacos[2]}-${dataAberturaPedacos[1]}-${dataAberturaPedacos[0]} 00:00`;
        const dataAbertura = new Date(dataAberturaString);

        cliente.dataAbertura = dataAbertura;
      }

      if (cliente.dataSituacaoCadastralString) {
        const dataSituacaoCadastralPedacos = cliente.dataSituacaoCadastralString.split('/') ?? [];
        const dataSituacaoCadastralString = `${dataSituacaoCadastralPedacos[2]}-${dataSituacaoCadastralPedacos[1]}-${dataSituacaoCadastralPedacos[0]} 00:00`;
        const dataSituacaoCadastral = new Date(dataSituacaoCadastralString);

        cliente.dataSituacaoCadastral = dataSituacaoCadastral;
      }

      if (cliente.dataSituacaoEspecialString) {
        const dataSituacaoEspecialPedacos = cliente.dataSituacaoEspecialString.split('/') ?? [];
        const dataSituacaoEspecialString = `${dataSituacaoEspecialPedacos[2]}-${dataSituacaoEspecialPedacos[1]}-${dataSituacaoEspecialPedacos[0]} 00:00`;
        const dataSituacaoEspecial = new Date(dataSituacaoEspecialString);

        cliente.dataSituacaoEspecial = dataSituacaoEspecial;
      }

      if (cliente.clienteDesdeString) {
        const clienteDesdePedacos = cliente.clienteDesdeString.split('/') ?? [];
        const clienteDesdeString = `${clienteDesdePedacos[2]}-${clienteDesdePedacos[1]}-${clienteDesdePedacos[0]} 00:00`;
        const clienteDesde = new Date(clienteDesdeString);

        cliente.clienteDesde = clienteDesde;
      }

      if (cliente.id === 0) {
        await ClientesService.criar(cliente, funcaoSucesso, 'Cliente foi adicionado com sucesso');
      } else {
        await ClientesService.atualizar(cliente, funcaoSucesso, 'Cliente foi editado com sucesso');
      }
    }
  })

  useEffect(() => {
    formik.resetForm();

    if (cliente.id > 0) {
      formik.setValues(cliente);
    }

    // eslint-disable-next-line
  }, [cliente]);

  return <Modal size='xl' centered={true} show={show} onHide={toggleModal}>
    <div className="modal-content">

      <div className="modal-header" style={{ padding: '10px 15px 5px 35px' }}>
        <h5 className="modal-title titulo-modal">{title}</h5>
        <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
          <i onClick={() => toggleModal()} className="fas fa-times" style={{ color: '#5E6397' }} />
        </div>
      </div>

      <div className="modal-body col-md-12" style={{ display: 'flex', padding: '10px' }}>
        <div className="col-md-6" style={{ borderRight: '1px solid #ddd', margin: '0 10px', padding: '0 10px' }}>
          <div style={{ display: 'flex' }}>
            <div className="col-md-8" style={{ margin: '0 5px 0 -5px' }}>
              <label htmlFor="form-cnpj" className="form-label required">CNPJ</label>
              <MaskedInput mask={MASCARA_CNPJ} {...formik.getFieldProps('cnpj')} placeholder="00.000.000/0000-00" type="text" className={clsx(
                'form-control',
                {
                  'is-invalid': formik.touched.cnpj && formik.errors.cnpj
                },
                {
                  'is-valid': formik.touched.cnpj && !formik.errors.cnpj
                }
              )} id="form-cnpj" />
            </div>
            <div className="col-md-4">
              <label htmlFor="form-dataAberturaString" className="form-label required">Data de Abertura</label>
              <MaskedInput mask={MASCARA_DATA} {...formik.getFieldProps('dataAberturaString')} placeholder="00/00/0000" type="text" className={clsx(
                'form-control',
                {
                  'is-invalid': formik.touched.dataAberturaString && formik.errors.dataAberturaString
                },
                {
                  'is-valid': formik.touched.dataAberturaString && !formik.errors.dataAberturaString
                }
              )} id="form-dataAberturaString" />
            </div>
          </div>
          <div className="col-md-12 mt-5">
            <label htmlFor="form-razaoSocial" className="form-label required">Razão Social</label>
            <input {...formik.getFieldProps('razaoSocial')} placeholder="Digite Algo" type="text" className={clsx(
              'form-control',
              {
                'is-invalid': formik.touched.razaoSocial && formik.errors.razaoSocial
              },
              {
                'is-valid': formik.touched.razaoSocial && !formik.errors.razaoSocial
              }
            )} id="form-razaoSocial" />
          </div>
          <div className="mt-5" style={{ display: 'flex' }}>
            <div className="col-md-9" style={{ margin: '0 5px 0 -5px' }}>
              <label htmlFor="form-nomeFantasia" className="form-label required">Nome Fantasia</label>
              <input {...formik.getFieldProps('nomeFantasia')} placeholder="Digite Algo" type="text" className={clsx(
                'form-control',
                {
                  'is-invalid': formik.touched.nomeFantasia && formik.errors.nomeFantasia
                },
                {
                  'is-valid': formik.touched.nomeFantasia && !formik.errors.nomeFantasia
                }
              )} id="form-nomeFantasia" />
            </div>
            <div className="col-md-3">
              <label htmlFor="form-porte" className="form-label required">Porte</label>
              <input {...formik.getFieldProps('porte')} placeholder="Digite Algo" type="text" className={clsx(
                'form-control',
                {
                  'is-invalid': formik.touched.porte && formik.errors.porte
                },
                {
                  'is-valid': formik.touched.porte && !formik.errors.porte
                }
              )} id="form-porte" style={{ padding: '10px' }} />
            </div>
          </div>
          <div className="col-md-12 mt-5">
            <label htmlFor="form-atividadePrincipal" className="form-label required">Código e Descrição da Atividade Principal</label>
            <input {...formik.getFieldProps('atividadePrincipal')} placeholder="Digite Algo" type="text" className={clsx(
              'form-control',
              {
                'is-invalid': formik.touched.atividadePrincipal && formik.errors.atividadePrincipal
              },
              {
                'is-valid': formik.touched.atividadePrincipal && !formik.errors.atividadePrincipal
              }
            )} id="form-atividadePrincipal" />
          </div>
          <div className="col-md-12 mt-5">
            <label htmlFor="form-atividadeSecundaria" className="form-label">Código e Descrição da Atividade Secundária</label>
            <input {...formik.getFieldProps('atividadeSecundaria')} placeholder="Digite Algo" type="text" className={clsx(
              'form-control',
              {
                'is-invalid': formik.touched.atividadeSecundaria && formik.errors.atividadeSecundaria
              },
              {
                'is-valid': formik.touched.atividadeSecundaria && !formik.errors.atividadeSecundaria
              }
            )} id="form-atividadeSecundaria" />
          </div>
          <div className="mt-5" style={{ display: 'flex' }}>
            <div className="col-md-9" style={{ margin: '0 5px 0 -5px' }}>
              <label htmlFor="form-endereco" className="form-label required">Endereço</label>
              <input {...formik.getFieldProps('endereco')} placeholder="Digite Algo" type="text" className={clsx(
                'form-control',
                {
                  'is-invalid': formik.touched.endereco && formik.errors.endereco
                },
                {
                  'is-valid': formik.touched.endereco && !formik.errors.endereco
                }
              )} id="form-endereco" />
            </div>
            <div className="col-md-3">
              <label htmlFor="form-numero" className="form-label required">Número</label>
              <input {...formik.getFieldProps('numero')} placeholder="Digite Algo" type="text" className={clsx(
                'form-control',
                {
                  'is-invalid': formik.touched.numero && formik.errors.numero
                },
                {
                  'is-valid': formik.touched.numero && !formik.errors.numero
                }
              )} id="form-numero" style={{ padding: '10px' }} />
            </div>
          </div>
          <div className="mt-5" style={{ display: 'flex' }}>
            <div className="col-md-9" style={{ margin: '0 5px 0 -5px' }}>
              <label htmlFor="form-complemento" className="form-label">Complemento</label>
              <input {...formik.getFieldProps('complemento')} placeholder="Digite Algo" type="text" className={clsx(
                'form-control',
                {
                  'is-invalid': formik.touched.complemento && formik.errors.complemento
                },
                {
                  'is-valid': formik.touched.complemento && !formik.errors.complemento
                }
              )} id="form-complemento" />
            </div>
            <div className="col-md-3">
              <label htmlFor="form-cep" className="form-label required">CEP</label>
              <MaskedInput mask={MASCARA_CEP} {...formik.getFieldProps('cep')} style={{ padding: '10px 0 10px 10px' }} placeholder="00000-000" type="text" className={clsx(
                'form-control',
                {
                  'is-invalid': formik.touched.cep && formik.errors.cep,
                },
                {
                  'is-valid': formik.touched.cep && !formik.errors.cep,
                }
              )} id="form-cep" />
            </div>
          </div>
        </div>

        <div>
          <div style={{ display: 'flex' }}>
            <div className="col-md-3" style={{ marginRight: '5px' }}>
              <label htmlFor="form-bairro" className="form-label required">Bairro</label>
              <input {...formik.getFieldProps('bairro')} placeholder="Digite Algo" type="text" className={clsx(
                'form-control',
                {
                  'is-invalid': formik.touched.bairro && formik.errors.bairro
                },
                {
                  'is-valid': formik.touched.bairro && !formik.errors.bairro
                }
              )} id="form-bairro" />
            </div>
            <div className="col-md-3">
              <label htmlFor="form-estado" className="form-label required">Estado</label>
              <select {...formik.getFieldProps('estado')} placeholder="UF" className={clsx(
                'form-select',
                {
                  'is-invalid': formik.touched.estado && formik.errors.estado
                },
                {
                  'is-valid': formik.touched.estado && !formik.errors.estado
                }
              )} id="form-estado" onChange={async e => {
                await formik.setFieldValue('estado', e.target.value);
                if (e.target.value) {
                  await IBGEService.pesquisarMunicipios(e.target.value, x => setMunicipios(x));
                }
              }}>
                <option value="" hidden>UF</option>
                {
                  LISTA_ESTADOS.map((x, index) => <option key={index}>{x}</option>)
                }
              </select>
            </div>
            <div className="col-md-4" style={{ marginRight: '5px' }}>
              <label htmlFor="form-cidade" className="form-label required">Cidade </label>
              <select disabled={formik.values.estado === ''} {...formik.getFieldProps('cidade')} onChange={async e => await formik.setFieldValue('cidade', e.target.value)} className={clsx(
                'form-select',
                {
                  'is-invalid': formik.touched.cidade && formik.errors.cidade
                },
                {
                  'is-valid': formik.touched.cidade && !formik.errors.cidade
                }
              )} id="form-cidade">

                <option value="" hidden>Selecione</option>
                {
                  municipios.map((x, index) => <option value={x.nome} key={index}>{x.nome}</option>)
                }
              </select>
            </div>

          </div>
          <div className="col-md-11 mt-5">
            <label htmlFor="form-email" className="form-label required">E-mail</label>
            <input {...formik.getFieldProps('email')} placeholder="Digite Algo" type="text" className={clsx(
              'form-control',
              {
                'is-invalid': formik.touched.email && formik.errors.email
              },
              {
                'is-valid': formik.touched.email && !formik.errors.email
              }
            )} id="form-email" />
          </div>
          <div className="mt-5" style={{ display: 'flex' }}>
            <div className="col-md-6" style={{ marginRight: '5px' }}>
              <label htmlFor="form-telefone" className="form-label required">Telefone</label>
              <MaskedInput mask={MASCARA_TELEFONE} {...formik.getFieldProps('telefone')} placeholder="Digite Algo" type="text" className={clsx(
                'form-control',
                {
                  'is-invalid': formik.touched.telefone && formik.errors.telefone
                },
                {
                  'is-valid': formik.touched.telefone && !formik.errors.telefone
                }
              )} id="form-telefone" />
            </div>
            <div className="col-md-5" style={{ width: 'calc(41.6666667% - 5px)' }}>
              <label htmlFor="form-telefoneAdicional" className="form-label">Telefone Adcional</label>
              <MaskedInput mask={MASCARA_TELEFONE} {...formik.getFieldProps('telefoneAdicional')} placeholder="Digite Algo" type="text" className={clsx(
                'form-control',
                {
                  'is-invalid': formik.touched.telefoneAdicional && formik.errors.telefoneAdicional
                },
                {
                  'is-valid': formik.touched.telefoneAdicional && !formik.errors.telefoneAdicional
                }
              )} id="form-telefoneAdicional" />
            </div>
          </div>
          <div className="mt-5" style={{ display: 'flex' }}>
            <div className="col-md-8" style={{ marginRight: '5px' }}>
              <label htmlFor="form-situacaoCadastral" className="form-label required">Situação Cadastral</label>
              <input {...formik.getFieldProps('situacaoCadastral')} placeholder="Digite Algo" type="text" className={clsx(
                'form-control',
                {
                  'is-invalid': formik.touched.situacaoCadastral && formik.errors.situacaoCadastral
                },
                {
                  'is-valid': formik.touched.situacaoCadastral && !formik.errors.situacaoCadastral
                }
              )} id="form-situacaoCadastral" />
            </div>
            <div className="col-md-3" style={{ width: 'calc(25% - 5px)' }}>
              <label htmlFor="form-dataSituacaoCadastralString" className="form-label required">Data da Situação Cad.</label>
              <MaskedInput mask={MASCARA_DATA} {...formik.getFieldProps('dataSituacaoCadastralString')} placeholder="00/00/0000" type="text" className={clsx(
                'form-control',
                {
                  'is-invalid': formik.touched.dataSituacaoCadastralString && formik.errors.dataSituacaoCadastralString
                },
                {
                  'is-valid': formik.touched.dataSituacaoCadastralString && !formik.errors.dataSituacaoCadastralString
                }
              )} id="form-dataSituacaoCadastralString" />
            </div>
          </div>
          <div className="col-md-11 mt-5">
            <label htmlFor="form-motivoSituacaoCadastral" className="form-label">Motivo da Situação Cadastral</label>
            <input {...formik.getFieldProps('motivoSituacaoCadastral')} placeholder="Digite Algo" type="text" className={clsx(
              'form-control',
              {
                'is-invalid': formik.touched.motivoSituacaoCadastral && formik.errors.motivoSituacaoCadastral
              },
              {
                'is-valid': formik.touched.motivoSituacaoCadastral && !formik.errors.motivoSituacaoCadastral
              }
            )} id="form-motivoSituacaoCadastral" />
          </div>
          <div className="mt-5" style={{ display: 'flex' }}>
            <div className="col-md-8" style={{ marginRight: '5px' }}>
              <label htmlFor="form-situacaoEspecial" className="form-label">Situação Especial</label>
              <input {...formik.getFieldProps('situacaoEspecial')} placeholder="Digite Algo" type="text" className={clsx(
                'form-control',
                {
                  'is-invalid': formik.touched.situacaoEspecial && formik.errors.situacaoEspecial
                },
                {
                  'is-valid': formik.touched.situacaoEspecial && !formik.errors.situacaoEspecial
                }
              )} id="form-situacaoEspecial" />
            </div>
            <div className="col-md-3" style={{ width: 'calc(25% - 5px)' }}>
              <label htmlFor="form-dataSituacaoEspecialString" className="form-label">Data da Situação Esp.</label>
              <MaskedInput mask={MASCARA_DATA} {...formik.getFieldProps('dataSituacaoEspecialString')} placeholder="00/00/0000" type="text" className={clsx(
                'form-control',
                {
                  'is-invalid': formik.touched.dataSituacaoEspecialString && formik.errors.dataSituacaoEspecialString
                },
                {
                  'is-valid': formik.touched.dataSituacaoEspecialString && !formik.errors.dataSituacaoEspecialString
                }
              )} id="form-dataSituacaoEspecialString" />
            </div>
          </div>
          <div className="col-md-5 mt-5">
            <label htmlFor="form-clienteDesdeString" className="form-label required">Cliente Desde</label>
            <MaskedInput mask={MASCARA_DATA} {...formik.getFieldProps('clienteDesdeString')} placeholder="00/00/0000" type="text" className={clsx(
              'form-control',
              {
                'is-invalid': formik.touched.clienteDesdeString && formik.errors.clienteDesdeString
              },
              {
                'is-valid': formik.touched.clienteDesdeString && !formik.errors.clienteDesdeString
              }
            )} id="form-clienteDesdeString" />
          </div>
        </div>
      </div>

      <div className="modal-footer" style={{ margin: '0 auto' }}>
        <button disabled={formik.isSubmitting} onClick={() => toggleModal()} type="button" className="btn btn-modal-cancelar me-5"> CANCELAR </button>
        <button disabled={formik.isSubmitting || !formik.isValid} onClick={async () => await formik.submitForm()} type="button" className="btn btn-primario ms-5">
          {!formik.isSubmitting && ((cliente?.id ?? 0) === 0 ? 'ADICIONAR' : 'EDITAR')}
          {
            formik.isSubmitting && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                Salvando...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
        </button>
      </div>
    </div>
  </Modal>
}

export default ClientesModal;